import {
  getCompounds,
  removeCompound,
  setCompoundFilters,
  updateCompound,
} from '@state/reducers/compoundReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { CompoundDto } from '@services/dtos'
import CompoundForm from '@components/forms/CompoundForm'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import { CompoundTypeLabels } from '@utils/constants'

export default function CompoundsTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setCompoundFilters({ includeInactive: false }))
    }
  }, [])
    
  const columns: GridColumns<CompoundDto> = useMemo(
    () => [
      { field: 'name', headerName: 'Nom', width: 200 },
      { field: 'type', headerName: 'Type', width: 125, valueGetter: (params) => CompoundTypeLabels[params.row.type] },
      {
        field: 'isotopeNames',
        headerName: 'Isotopes',
        width: 200,
        valueGetter: (params) => params.row.isotopes.map((iso) => iso.name).join(', '),
      },
      { field: 'coldKit', headerName: 'Trousse', width: 150, valueGetter: (params) => params.row.coldKit ? params.row.coldKit.name : '' },
      { field: 'description', headerName: 'Description', width: 300 },
      { field: 'eluateMaxAgeMinutes', headerName: 'Fraîcheur éluat requise (minutes)', width: 125 },
      { field: 'preparationMaxAgeMinutes', headerName: 'Âge max préparation (minutes)', width: 125 },
    ],
    [],
  )

  return (
    <BaseConfigTable<CompoundDto>
      columns={columns}
      selectRows={(state) => state.compound.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setCompoundFilters({ includeInactive: true }))
        return dispatch(getCompounds())
      }}
      deleteThunk={removeCompound}
      toggleThunk={(id, isActive) => updateCompound({ id, dto: { isActive } })}
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setCompoundFilters({ page }))
        dispatch(getCompounds())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <CompoundForm editingCompound={editingItem} onClose={onClose} />
      )}
      resourceLabel="MRP"
      resourcePrefix="le "
    />
  )
}
